var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHqDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32812 3.23438H6.1875C6.26484 3.23438 6.32812 3.17109 6.32812 3.09375V3.23438H11.6719V3.09375C11.6719 3.17109 11.7352 3.23438 11.8125 3.23438H11.6719V4.5H12.9375V3.09375C12.9375 2.47324 12.433 1.96875 11.8125 1.96875H6.1875C5.56699 1.96875 5.0625 2.47324 5.0625 3.09375V4.5H6.32812V3.23438ZM15.1875 4.5H2.8125C2.50137 4.5 2.25 4.75137 2.25 5.0625V5.625C2.25 5.70234 2.31328 5.76562 2.39062 5.76562H3.45234L3.88652 14.959C3.91465 15.5584 4.41035 16.0312 5.00977 16.0312H12.9902C13.5914 16.0312 14.0854 15.5602 14.1135 14.959L14.5477 5.76562H15.6094C15.6867 5.76562 15.75 5.70234 15.75 5.625V5.0625C15.75 4.75137 15.4986 4.5 15.1875 4.5ZM12.8549 14.7656H5.14512L4.71973 5.76562H13.2803L12.8549 14.7656Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHqDelete);
export default __webpack_public_path__ + "static/media/hq-delete.42b732b952da58484b0cf3f35439b7f7.svg";
export { ForwardRef as ReactComponent };